import React, { Suspense, useContext } from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'
import { CContainer, CSpinner } from '@coreui/react'

// routes config
import routes from '../routes'
import { Usercntxt } from './../context/UserContext'

const AppContent = () => {
  const user = useContext(Usercntxt)
  return (
    <CContainer lg>
      <Suspense fallback={<CSpinner color="primary" />}>
        <Switch>
          {routes.map((route, idx) => {
            return (
              user.can(route.permission) && (
                <Route
                  key={idx}
                  path={route.path}
                  exact={route.exact}
                  name={route.name}
                  render={(props) => (
                    <>
                      <route.component {...props} />
                    </>
                  )}
                />
              )
            )
          })}
          <Redirect from="/" to="/orders" />
        </Switch>
      </Suspense>
    </CContainer>
  )
}

export default React.memo(AppContent)
